import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7eab8045"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "contextDiv" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"24px","font-weight":"bold"} }, " 面试题库 ", -1))
const _hoisted_4 = { class: "des" }

import { ref, watchEffect } from "vue";
import API from "@/api";
import message from "@arco-design/web-vue/es/message";
import { listInterviewQuestionBankVoByPageUsingPost } from "@/request/api/interviewQuestionBankController";
import router from "@/router";

interface Props {
  pageSize: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InterviewQuestionBankPage',
  props: {
    pageSize: { default: () => {
    return 20;
  } }
  },
  setup(__props: any) {

const props = __props;
// 题库搜索条件
const searchParams = ref<API.InterviewQuestionBankQueryRequest>({
  current: 1,
  pageSize: props.pageSize,
  sortField: "createTime",
  sortOrder: "ascend",
});
// 题目搜索关键词
const searchText = ref("");
//数据
const dataList = ref<API.InterviewQuestionBankVO[]>([]);
//总值
const total = ref<number>(0);
const loading = ref(false);

/**
 * 搜索
 */
const search = async () => {
  if (searchText.value == "") {
    await loadData();
    return;
  }
  const response = await listInterviewQuestionBankVoByPageUsingPost({
    searchText: searchText.value,
    ...searchParams.value,
  });
  if (response.data.code === 0) {
    dataList.value = response.data.data?.records || [];
    total.value = response.data.data?.total || 0;
  } else {
    message.error("加载数据失败，" + response.data.message);
  }
};

/**
 * 加载数据
 */
const loadData = async () => {
  loading.value = true;
  const response = await listInterviewQuestionBankVoByPageUsingPost(
    searchParams.value
  );
  if (response.data.code === 0) {
    dataList.value = response.data.data?.records || [];
    total.value = response.data.data?.total || 0;
  } else {
    message.error("加载数据失败，" + response.data.message);
  }
  loading.value = false;
};
/**
 * 监听 searchParams 变量，改变时触发数据的重新加载
 */
watchEffect(() => {
  loadData();
});

/**
 * 当分页变化时，改变搜索条件，触发数据加载
 */
const onPageChange = (page: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: page,
  };
};

/**
 * 点击题库
 */
const click = (id: number) => {
  router.push({
    path: `/bank/detail/${id}`,
  });
};

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_list = _resolveComponent("a-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_row, { style: {"margin":"20px 0","width":"100%"} }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { flex: "100px" }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, { flex: "auto" }),
          _createVNode(_component_a_col, { flex: "275px" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input_search, {
                placeholder: "搜索题库",
                modelValue: searchText.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
                onSearch: search,
                onKeyup: _withKeys(search, ["enter"]),
                "search-button": ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_list, {
        "grid-props": { gutter: [20, 20], md: 6 },
        bordered: false,
        data: dataList.value,
        "pagination-props": {
          pageSize: searchParams.value.pageSize,
          current: searchParams.value.current,
          total: total.value,
        },
        loading: loading.value,
        onPageChange: onPageChange
      }, {
        item: _withCtx(({ item }) => [
          _createVNode(_component_a_card, {
            hoverable: "",
            class: "card",
            onClick: ($event: any) => (click(item.id))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_space, { size: "medium" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_image, {
                    src: item.picture,
                    width: "40"
                  }, null, 8, ["src"]),
                  _createVNode(_component_a_space, { direction: "vertical" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_typography_text, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.title), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createElementVNode("div", _hoisted_4, _toDisplayString(item.description), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _: 1
      }, 8, ["data", "pagination-props", "loading"])
    ])
  ]))
}
}

})